import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Section index label e.g. "01 / PARTS"
export const SectionTag = ({ index, label }) => (
  <div
    className="flex items-center gap-3 mb-6"
    data-testid={`section-tag-${label.toLowerCase().replace(/\s+/g, "-")}`}
  >
    <span className="font-mono-rp text-[#e31e24] text-sm tracking-widest">
      {index}
    </span>
    <span className="h-px w-10 bg-[#e31e24]" />
    <span className="font-mono-rp text-white/60 text-xs tracking-[0.35em] uppercase">
      {label}
    </span>
  </div>
);
